import {
    CoreFetch,
    DocumentApi,
    DocumentUpload,
    ListProviderDocumentsRequest,
    ProviderCreateDocumentPayload,
    ProviderDocument,
} from '@enter/core';
import { IItemListing } from './root.store';
import { fetch, parseResponse } from './util';

export class DocumentService {
    public async fetchDocumentListing(
        lpgr: ListProviderDocumentsRequest,
    ): Promise<IItemListing<ProviderDocument> | undefined> {
        const res = await fetch(lpgr, req =>
            CoreFetch<DocumentApi>(DocumentApi).listProviderDocumentsRaw(req),
        );
        if (res) {
            return {
                items: await parseResponse(res),
                limit: Number(await res.raw.headers.get('pagination-limit')),
                offset: Number(await res.raw.headers.get('pagination-offset')),
                total: Number(await res.raw.headers.get('pagination-total')),
            };
        }
    }

    public async createProviderDocument(payload: ProviderCreateDocumentPayload): Promise<ProviderDocument> {
        return CoreFetch<DocumentApi>(DocumentApi).createProviderDocument({
            providerCreateDocumentPayload: payload,
        });
    }

    public async createProviderDocumentUpload(id: string): Promise<DocumentUpload> {
        return CoreFetch<DocumentApi>(DocumentApi).createProviderDocumentUpload({
            id,
            body: {},
        });
    }

    public async refreshProviderDocumentMetadata(id: string): Promise<void> {
        await CoreFetch<DocumentApi>(DocumentApi).refreshProviderDocumentMetadata({
            id,
            body: {},
        });
    }
}
